<template>
  <div class="footer" >
    <div class="top">
      <a class="left" @click="goNewsPage('')">
        <div class="logo">
        <img alt='商城logo'
             :src="common.showPic(logo)"
             onerror="@/assets/images/LOGO.png">

          <img src="@/assets/images/weach.jpg" style="width: auto; height: auto; max-width: 100%; max-height: 100%;">
        </div>
      </a>
      <div class="describe">
        <Row type="flex"
             justify="space-between">
          <Col>
            <p>官方热线</p>
            <ul>
              <li style="padding: 5px 10px 0px 0px;color: #8e8e8e;font-size: 16px; ">{{servicePhone}}</li>

            </ul>

            <ul class="title_li">
              <li ><span v-html="qqInfo.name"></span></li>
            </ul>
          </Col>
          <Col v-if="helpList && helpList.length">
          <p>帮助中心</p>
          <ul class="title_li">
            <li v-for="(item,index) in helpList"
                :key="index"
                @click="goArticleDetail(item,1)">{{item.classifyName}}</li>
          </ul>
          </Col>
          <Col v-if="systemlist && systemlist.length">
          <p>系统快报</p>
          <ul class="title_li">
            <li v-for="(item,index) in systemlist"
                :key="index"
                @click="goArticleDetail(item,2)">{{item.classifyName}}</li>
          </ul>
          </Col>
          <Col v-if="noticeList && noticeList.length">
          <p>商城公告</p>
          <ul class="title_li">
            <li v-for="(item,index) in noticeList"
                :key="index"
                @click="goArticleDetail(item,3)">{{item.classifyName}}</li>
          </ul>
          </Col>
          <Col v-if="newsList && newsList.length">
          <p>新闻资讯</p>
          <ul class="title_li">
            <li v-for="(item,index) in newsList"
                :key="index"
                @click="goNewsDetail(item,8)">{{item.classifyName}}
            </li>
          </ul>
          </Col>
          <!-- <Col v-if="businessList && businessList.length">
          <p>电商快报</p>
          <ul class="title_li">
            <li v-for="(item,index) in businessList"
                :key="index"
                @click="goArticleDetail(item,4)">{{item.classifyName}}
            </li>
          </ul>
          </Col> -->
          <Col v-if="distributionList && distributionList.length">
          <p>分销须知</p>
          <ul class="title_li">
            <li v-for="(item,index) in distributionList"
                :key="index"
                @click="goArticleDetail(item,12)">{{item.classifyName}}</li>
          </ul>
          </Col>
        </Row>
      </div>
      <!--      <Row type="flex" :gutter="10" class="code_img">-->
      <!--        <Col>-->
      <!--          <img src="@/assets/images/erweima.png" alt="">-->
      <!--          <p>公众号</p>-->
      <!--        </Col>-->
      <!--        <Col>-->
      <!--          <img src="@/assets/images/erweima.png" alt="">-->
      <!--          <p>小程序</p>-->
      <!--        </Col>-->
      <!--      </Row>-->
    </div>
    <div class="bottom">
      <!-- 友情链接 -->
      <div class="friend-ship">
        <a v-for="(item, index) in linkList"
           :key="index"
           :href="item.url"
           target="_blank">{{item.name}}</a>
      </div>
      <!-- 客服信息 -->
<!--      <div style="display:flex;justify-content: center;">
        &lt;!&ndash; <span v-for="(item,index) in serviceList"
              :key="index">
          {{item.name}}：
          <a style="padding: 0;"
             :href="'https://wpa.qq.com/msgrd?v=3&uin=' + item.value + '&site=qq&menu=yes'"
             target="_blank">{{item.value}}</a>
        </span> &ndash;&gt;
        <span v-html="qqInfo.name"></span>
        热线电话：
        <a style="padding: 0;"
           :href="'tel:' + servicePhone">{{servicePhone}}</a>
      </div>-->
      <!-- 版权信息 -->
      <!-- <div>
        Copyright 2020 , All Rights Reserved ICP证 ：<a href="https://beian.miit.gov.cn"
           target="_blank">{{$store.state.mallIcp}}</a> 版权所有：{{$store.state.companyName}}
      </div> -->
<!--       <div>{{versionsInfo}}</div> -->
      <div class="background-color: #c1bbbb;" v-html="versionsInfo"></div>
    </div>

  </div>

</template>

<script>
import { configData, getNewsListByParentId, friendshipLinkList } from '@/api/index'
export default {
  name: 'index',
  data() {
    return {
      logo: require('@/assets/images/LOGO.png'),
      serviceList: [],
      qqInfo: {},
      servicePhone: null,
      versionsInfo: null,       // 版本信息
      helpList: [],
      systemlist: [],
      distributionList: [],
      businessList: [],
      noticeList: [],
      newsList: [],
      linkList: []
    }
  },
  created() {
    if (this.$store.state.mallLogo) {
      this.logo = this.$store.state.mallLogo
    }
    this.init()
    this.getNewsListByParentId()
  },
  methods: {
    getNewsListByParentId() {
      // 帮助中心
      getNewsListByParentId({ parentId: 1, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.helpList.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
      // 系统快报
      getNewsListByParentId({ parentId: 2, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.systemlist.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
      // 新闻资讯
      getNewsListByParentId({ parentId: 8, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.newsList.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
      // 电商快报
      getNewsListByParentId({ parentId: 4, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.businessList.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
      // 分销须知
      // getNewsListByParentId({parentId:12,pageNum:1,pageSize: 4}).then(res => {
      //   res.data.forEach(item => {
      //     this.distributionList.push({
      //       id: item.id,
      //       classifyName: item.classifyName,
      //       classifyLevel: item.classifyLevel
      //     })
      //   })
      // })
      // 商城公告
      getNewsListByParentId({ parentId: 3, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.noticeList.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
    },
    goAdmin() {
      // 前往卖家工作台
      window.open(this.ADMIN_URL, '_blank')
    },
    init() {
      configData({ key: 'P_serviceQQ', tips: '客服qq' }).then(res => {
        this.qqInfo = res.data
        let value = res.data.name
        if (value) {
          value = value.split(/,|，/g)
          this.serviceList = value.map(item => {
            let arr = item.split('|')
            return { name: 'QQ' + arr[0], value: arr[1] }
          })
        }
      })
      configData({ key: 'P_servicePhone', tips: '客服电话' }).then(res => {
        this.servicePhone = res.data.name
      })
      // 获取版本信息
      configData({ key: 'P_copyright', tips: '版权信息' }).then(res => {
        this.versionsInfo = res.data.name
      })
    /*  console.log('当前路由', this.$route)
      console.log('当前路由', window.location)*/
      if (this.$route.name == 'index') {
        // 首页下显示友情链接数据
        friendshipLinkList({ showType: 1 }).then(res => {
          this.linkList = res.data
        })
      } else if (this.$route.name == 'shopIndex' || this.$route.name == 'newReleases' || this.$route.name == 'goods' || this.$route.name == 'clearInventory'
        || this.$route.name == 'offGoods' || this.$route.name == 'download' || this.$route.name == 'about') {
        // 店铺下显示友情链接数据
        friendshipLinkList({ showType: 3 }).then(res => {
          this.linkList = res.data
        })
      } else {
        // 首页自定义栏目跳转显示的友情链接数据
        friendshipLinkList({ showType: 2 }).then(res => {
          this.linkList = res.data
        })
      }
    },
    goArticleDetail(item, type) {
      window.open(this.DOMAIN_URL + '/xinxi-'+item.id, '_self')
      this.$router.push({
        path: '/help',
        query: {
          classifyLevel: 2,
          firstId: type,
          classityId: item.id
        }
      })
    },
    // 新闻详情
    goNewsPage(url) {
      window.open(this.DOMAIN_URL+url, '_self')
      /*this.$router.push({
        path: '/news',
        query: {
          classifyLevel: 2,
          classityId: item.id
        }
      })*/
    },
    // 新闻详情
    goNewsDetail(item, type) {
      window.open(this.DOMAIN_URL + '/xinxi-'+item.id, '_self')
      /*this.$router.push({
        path: '/news',
        query: {
          classifyLevel: 2,
          classityId: item.id
        }
      })*/
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  background: white;
}
.bottom ::v-deep a{
  color: #c1bbbb;
}
.title_li ::v-deep a{
  color: rgb(142, 142, 142);
}
.top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 1200px;
  margin: 0 auto;
  padding: 45px 20px 50px 20px;
}

.left {
  /*margin-left: 45px;*/

  .logo {
    width: 250px;
    padding-right: 55px;
    border-right: 1px solid #ccc;
  }
}

.describe {
  flex: 1;
  margin: 0 55px;
  text-align: left;
}

.describe p {
  font-size: 16px;
  color: #5b5b5b;
}

.describe ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title_li {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 14px;
  color: #8e8e8e;
  margin-top: 5px;
  cursor: pointer;
}

.title_li li:nth-child(1) {
  cursor: pointer;
}

.code_img {
  font-size: 12px;
  color: #999999;

  img {
    width: 80px;
    height: 80px;
  }
}

.bottom {
  padding: 20px 0;
  font-size: 12px;
  font-weight: 500;
  color: #c1bbbb;
  background: #2a2a29;
  line-height: 33px;
  border-top: 1px solid #f5f5f5;

  .friend-ship {
    text-align: center;
    a {
      margin: 0 10px;
      color: #c1bbbb;
    }
  }
}

</style>
